import { render } from "./BaseLoader.vue?vue&type=template&id=c5d2fc70&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=c5d2fc70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d2fc70"]])

export default __exports__